import { types } from "../types/types";

export const startFormValid = (formName) => ({
    type: types.formsValidStart,
    payload: formName
});

export const finishFormValid = (formName) => ({
    type: types.formsValidFinish,
    payload: formName
});

export const errorFormValid = (formName, msg) => ({
    type: types.formsValidError,
    payload: {
        formName,
        msg
    }
});

export const msgFormValid = (formName, msg) => ({
    type: types.formsValidMsg,
    payload: {
        formName,
        msg
    }
});